import { render, staticRenderFns } from "./MealAppraiseList.vue?vue&type=template&id=501b559c&"
import script from "./MealAppraiseList.vue?vue&type=script&lang=js&"
export * from "./MealAppraiseList.vue?vue&type=script&lang=js&"
import style0 from "./MealAppraiseList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports